import { render, staticRenderFns } from "./marques-by-region.vue?vue&type=template&id=4e94879c"
import script from "./marques-by-region.vue?vue&type=script&lang=js"
export * from "./marques-by-region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports